import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Checkbox, Modal, Divider, Row, Col, Input, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Apple, CloseIcon, Google, Info } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import { EmailLoginField } from '../../components/SharedComponents/FormComponents/EmailLoginField'; 
import { PasswordLoginField } from '../../components/SharedComponents/FormComponents/PasswordLoginField';
import { Images } from '../../config/images';
import './Login.scss';
import { login, resendEmailApi } from '../../services/authApi/authApi';
import { toastNotify } from '../../utils/toastNotify';
import { accountReactivationLinkAction } from '../../store/reducer/accountActivationSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { addUserData, resetUserData } from '../../store/reducer/accountSlice';
import { realBricksApi } from '../../utils/axiosInterceptors';
import { useGoogleLogin } from '@react-oauth/google';
import { LoginSocialApple } from 'reactjs-social-login';
import { onlyAlphabetRegex, phoneRegex } from '../../utils/Validations';
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { AES } from 'crypto-js'
import { formatePhoneNumber } from '../../utils/formatPhoneNumber';

const Login = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [viewForm, setViewForm] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoginButtonActive, setIsLoginButtonActive] = useState(true);
  const [clickCount, setClickCount] = useState(0);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [referredBy, setReferredBy] = useState('');
  const [subscribeForSMS, setSubscribeForSMS] = useState(false);
  const [userResponseGoogle, setUserResponseGoogle] = useState(null);
  const [responseApple, setResponseApple] = useState(null);
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [socialDataLoaded, setSocialDataLoaded] = useState(false);
  const [dataManuallyEdited, setDataManuallyEdited] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaValue, setCaptchaValue] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState('');
  const [referralCodeError, setReferralCodeError] = useState('');
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const search = useLocation().search;
  const referralLink = new URLSearchParams(search).get('referredBy');
  // const location = useLocation();
  // // const from = location.state?.from || '/';
  const dispatch = useDispatch();
  const userProfileData = useSelector((state) => state.userData.userData);

  useEffect(() => {
    // let cookieToken = getCookie('tokenData');
    var input = document.getElementById('email');
    setTimeout(() => {
      if (input.matches(':-internal-autofill-selected')) {
        setIsLoginButtonActive(false);
        /* do something */
      }
    }, 500);

    // cookieToken = cookieToken && JSON.parse(cookieToken);
    // if (cookieToken && cookieToken.access_token) {
    //   localStorage.setItem('access_token', cookieToken.access_token);
    //   localStorage.setItem('refresh_token', cookieToken.refresh_token);
    //   navigate('/login/enterpin');
    // }
    if (Object.keys(userProfileData).length && localStorage.getItem('access_token')) {
      navigate('/');
    }
    if (localStorage.getItem('showRecaptcha') === 'true') {
      setShowCaptcha(true);
      localStorage.clear('showRecaptcha')
    }
  }, []);

  const setSocialNameData = (data) => {
    setFirstName(data.firstName || '');
    setLastName(data.lastName || '');
    setPhoneNumber(data.phoneNumber || '');
    setReferredBy(data.referredBy || '');
    setSocialDataLoaded(true);
  };

  useEffect(() => {
    validateFormData();
  }, [setSocialNameData]);

  useEffect(() => {
    if (referralLink) {
      setReferredBy(referralLink);
    }
  }, [referralLink]);

  const validateFormData = () => {
    if (dataManuallyEdited || (!firstName.trim() || !lastName.trim() || !phoneNumber.trim() || !referredBy.trim())) {
      handleFirstNameChange({ target: { value: firstName } });
      handleLastNameChange({ target: { value: lastName } });
      handlePhoneNumberChange({ target: { value: phoneNumber } });
      handleReferralCodeChange({ target: { value: referredBy } });
    }
  };

  const handleChangePhoneNumber = (e) => {
    const formattedNumber = formatePhoneNumber(e.target.value); 
    setPhoneNumber(formattedNumber);
  };

  const openNewSocialModal = () => {
    const isPinNotSetGoogleLogin = !userResponseGoogle?.data?.data?.isPinSet;
    const isPinNotSetAppleLogin = !responseApple?.data?.data?.isPinSet;
    if (isPinNotSetGoogleLogin || isPinNotSetAppleLogin) {
      setNewModalVisible(true)
    }
  };

  const closeNewSocialModal = () => {
    setFirstName('');
    setLastName('');
    setFirstNameError('');
    setLastNameError('');
    setNewModalVisible(false);
  };

  const handleDoneClick = async () => {
    try {
      setLoading(true);
      const accessToken = localStorage.getItem('access_token');
      const payload = {
        firstName,
        lastName,
      };

      // Include phone number in payload if it's not empty
      if (phoneNumber.trim() !== '') {
        const phoneNumberInp = `${phoneNumber.slice(1, 4)}${phoneNumber.slice(6, 9)}${phoneNumber.slice(10, 14)}`;
        payload.phoneNumber = phoneNumberInp;
      }

      // Include referral code in payload if it's not empty
      if (referredBy.trim() !== '') {
        payload.referredBy = referredBy.trim();
      }

      // Include referral code from URL if available
      if (referralLink) {
        payload.referredBy = referralLink;
      }

      if(!subscribeForSMS){
        payload.subscribeForSMS = false;
      }
      
      if (subscribeForSMS && phoneNumber.trim() !== '') {
        payload.subscribeForSMS = subscribeForSMS;
      }

      const apiResponse = await realBricksApi.put(
        `${process.env.REACT_APP_API_URL}/api/v1/user/social-name`,
        payload,
        {
          headers: {
            Authorization: `${accessToken}`
          }
        }
      );

      localStorage.setItem('email', apiResponse?.data?.data?.email);

      // Close the modal
      setNewModalVisible(false);
      navigate('/sign-up/createpin');
    } catch (error) {
      const {response} = error;
      toastNotify("error", response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFirstNameChange = (e) => {
    const value = e.target.value;

    setFirstName(value);
    setDataManuallyEdited(true);

    if (!value.trim()) {
      setFirstNameError('Please enter your Firstname.');
    } else if (value.length < 2 || value.length > 30) {
      setFirstNameError('Firstname Must be at least 2 characters and less than 30 characters');
    } else if (!onlyAlphabetRegex.test(value)) {
      setFirstNameError('Firstname should not contain any space,numbers or special characters');
    } else {
      setFirstNameError('');
    }
  };


  const handleLastNameChange = (e) => {
    const value = e.target.value;

    setLastName(value);
    setDataManuallyEdited(true);

    if (!value.trim()) {
      setLastNameError('Please enter your Lastname.');
    } else if (value.length < 2 || value.length > 30) {
      setLastNameError('Lastname Must be at least 2 characters and less than 30 characters');
    } else if (!onlyAlphabetRegex.test(value)) {
      setLastNameError('Lastname should not contain any space, numbers or special characters');
    } else {
      setLastNameError('');
    }
  };

  const handleReferralCodeChange = (e) => {
    const value = e.target.value;
    setReferredBy(value);
    setDataManuallyEdited(true);

    if (value.trim()) {
      if (value.length < 2 || value.length > 30) {
        setReferralCodeError('Referral code must be between 2 and 30 characters.');
      } else {
        setReferralCodeError('');
      }
    } else {
      setReferralCodeError('');
    }
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    setDataManuallyEdited(true);

    if (value.trim() && !phoneRegex.test(value)) {
      setPhoneNumberError('Please enter a valid phone number.');
    } else {
      setPhoneNumberError('');
    }
  };

  const hasErrors = !!firstNameError || !!lastNameError || !!phoneNumberError || !!referralCodeError;

  const onLoginSuccess = async (response) => {
    dispatch(resetUserData());
    localStorage.clear();
    const accessToken = response.access_token
    try {
      const userResponse = await realBricksApi.post(`${process.env.REACT_APP_API_URL}/api/v1/login/google?loginType=Web`, {}, {
        headers: {
          Authorization: `${accessToken}`,
        },
      })
      setUserResponseGoogle(userResponse);

      if (userResponse.data.data?.user?.isSignUp) {
        localStorage.setItem('email', userResponse.data.data.user.email)
        localStorage.setItem('access_token', userResponse?.data?.data?.accessToken)
        localStorage.setItem('access_token_temp', userResponse?.data?.data?.accessToken);
        localStorage.setItem('counter', userResponse.data.data.counter);
        setSocialNameData(userResponse?.data?.data?.user);
        if(userResponse?.data?.data?.isNameSet === true){
          if(userResponse?.data?.data?.isPinSet === false){
            navigate('/sign-up/createpin');
          } else {
            navigate('/login/enterpin')
          }
        } else {
          openNewSocialModal();
        }
      } else {
        localStorage.setItem('email', userResponse?.data?.data?.email);
        localStorage.setItem('access_token', userResponse?.data?.data?.accessToken)
        localStorage.setItem('access_token_temp', userResponse?.data?.data?.accessToken);
        localStorage.setItem('counter', userResponse.data.data.counter);

        if (userResponse?.data?.data?.isActive) {
          localStorage.setItem('email', userResponse?.data?.data?.email);
          localStorage.setItem('access_token', userResponse?.data?.data?.accessToken);
          localStorage.setItem('counter', userResponse?.data?.data?.counter);
          setSocialNameData(userResponse?.data?.data);
          if(userResponse?.data?.data?.isNameSet === true){
            if(userResponse?.data?.data?.isPinSet === false){
              navigate('/sign-up/createpin');
            } else {
              navigate('/login/enterpin')
            }
          } else {
            openNewSocialModal();
          }
        } else {
          // navigate('/');
          setOpenModal(true);
        }
      }
    } catch (error) {
      const { userResponse } = error;
      toastNotify('error', userResponse?.data?.message,);
    }
  }

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: onLoginSuccess,
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    accessType: 'offline',
  });

  const handleLoginClick = async (values) => {
    if (clickCount === 3) {
      localStorage.setItem('showRecaptcha', true);
      window.location.reload();
    } else {
      setClickCount(clickCount + 1)
      setLoading(true);
    }
  }

  const handleResendEmail = async () => {
    try {
      const res = await resendEmailApi();

      if (!res.isError) {
        toastNotify('success', res?.message);
      } else {
        toastNotify('error', res?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  };

  const handleResendEmailLink = async () => {
    await dispatch(accountReactivationLinkAction({}));
    setOpenModal(false);
  };

  const onAppleLoginSuccess = async (provider, data) => {
    dispatch(resetUserData());
    localStorage.clear();

    const idToken = data?.authorization?.id_token;

    try {
      const response = await realBricksApi.post(`${process.env.REACT_APP_API_URL}/api/v1/login/apple?loginType=Web`, {}, {
        headers: {
          Authorization: `${idToken}`,
        },
      })
      setResponseApple(response)
      if (response?.data?.data?.user?.isSignUp) {
        localStorage.setItem('email', response?.data?.data?.user?.email)
        localStorage.setItem('access_token', response?.data?.data?.accessToken)
        localStorage.setItem('access_token_temp', response?.data?.data?.accessToken)
        localStorage.setItem('counter', response?.data?.data?.counter);
        setSocialNameData(response?.data?.data?.user);
        if(response?.data?.data?.isNameSet === true){
          if(response?.data?.data?.isPinSet === false){
            navigate('/sign-up/createpin');
          } else {
            navigate('/login/enterpin')
          }
        } else{
          openNewSocialModal();
        }
      } else {
        localStorage.setItem('email', response?.data?.data?.email);
        localStorage.setItem('access_token', response?.data.data?.accessToken)
        localStorage.setItem('access_token_temp', response?.data.data?.accessToken)
        localStorage.setItem('counter', response?.data?.data?.counter);

        if (response?.data?.data?.isActive) {
          localStorage.setItem('email', response?.data?.data?.email);
          localStorage.setItem('access_token', response?.data?.data?.accessToken)
          localStorage.setItem('access_token_temp', response?.data.data?.accessToken)
          localStorage.setItem('counter', response?.data?.data?.counter);
          setSocialNameData(response?.data?.data);
          if(response?.data?.data?.isNameSet === true){
            if(response?.data?.data?.isPinSet === false){
              navigate('/sign-up/createpin');
            } else {
              navigate('/login/enterpin')
            }
          } else {
            openNewSocialModal();
          }
        } else {
          navigate('/');
          toastNotify('error','Something went wrong');
        }
      }
    }
    catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message,);
    }
  }

  const onResolve = ({ provider, data }) => {
    onAppleLoginSuccess(provider, data)
  }

  const onFinish = async (values) => {
    setLoading(true);
    if (showCaptcha) {
      setCaptchaValue('');
      setShowCaptcha(false);
      setClickCount(1);
    }
    try {
      const hashedPassword = AES.encrypt(values.password, process.env.REACT_APP_PASSWORD_ENCRYPT_KEY).toString();
      const userData = await login({ ...values, password: hashedPassword }, 'Web', rememberMe);
      if (!userData.isError) {
        await dispatch(addUserData({ userData: {}, isPinEntered: false }));
        localStorage.clear(); //clear localstorage
        const { accessToken, refreshToken = null, counter } = userData.data;
        await localStorage.setItem('access_token_temp', accessToken);
        refreshToken && (await localStorage.setItem('refresh_token', refreshToken));
        await localStorage.setItem('email', values.email);
        await localStorage.setItem('counter', counter);
        // const tokenData = {
        //   access_token: accessToken,
        //   refresh_token: refreshToken,
        // };
        // rememberMe && setCookie('tokenData', JSON.stringify(tokenData), 30);
        if (userData?.data?.isActive) {
          if (!userData.data.isEmailVerified) {
            await handleResendEmail();
            navigate('/sign-up/activation');
            return;
          }
          if (!userData.data.isPinSet) {
            navigate('/sign-up/createpin');
            return;
          }
          navigate('/login/enterpin');
        } else {
          setOpenModal(true);
        }
        // navigate('/login/enterpin');
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (value) => {
    setCaptchaValue(value);
  }
  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm
        className={viewForm ? 'show' : null}
        note={
          <>
            <span className='hide-mobile mr-4'>Don’t have an account?</span>
            <Link to='/sign-upAuth' className='underline fw-600 text-terracotta'>
              Sign up
            </Link>
          </>
        }
        title={<>Log in to your account</>}
      >
        <Row gutter={[16, 16]} className='mb-32 pt-10'>
          <Col span={24} lg={12}>
            <Button type='primary' className='ant-btn-primary--alt icon-btn' block onClick={() => handleGoogleLogin()}>
              <Google size={16} /> Continue with Google
            </Button>

          </Col>
          <Col span={24} lg={12}>
            <LoginSocialApple
              client_id={process.env.REACT_APP_APPLE_CLIENT_ID}
              // scope='name email'
              redirect_uri={process.env.REACT_APP_APPLE_REDIRECT_URL}
              onResolve={onResolve}
              onReject={err => {
                toastNotify('error',err);
              }}
            >
              <Button type='primary' className='ant-btn-primary--alt icon-btn' block>
                <Apple size={16} /> Continue with Apple
              </Button>
            </LoginSocialApple>
          </Col>
        </Row>
        <Divider plain>OR</Divider>
        <Form name='login-form' className='auth-form details-form' autoComplete='off' onFinish={onFinish} form={form}>
          <FloatingLabel label='Email' name='email' inputValue={email}>
            <EmailLoginField email={email} setEmail={(value) => setEmail(value)}/>
          </FloatingLabel>
          <FloatingLabel label='Password' name='password' inputValue={password}>
            <PasswordLoginField name={'password'} setPassword={(value) => setPassword(value)} password={password} validation={false} />
          </FloatingLabel>
          <Link to='/forgot-password/enter-email' className='underline fw-600 text-terracotta'>
            Forgot password
          </Link>
          {showCaptcha && <ReCAPTCHA
            className='mt-24'
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={onChange}
          />}
          <Form.Item className='auth-form__login-submit' shouldUpdate>
            {() => (
              <React.Fragment>
                <Checkbox onChange={(e) => setRememberMe(e.target.checked)}>Remember me for 30 days</Checkbox>
                <Button
                  type='primary'
                  htmlType='submit'
                  className='ant-btn-primary--alt'
                  loading={loading}
                  onClick={handleLoginClick}
                  disabled={
                    (showCaptcha && captchaValue === '') || (isLoginButtonActive && !form.isFieldsTouched(true)) || form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                  }
                >
                  Log in
                </Button>
                </React.Fragment>
            )}
          </Form.Item>
        </Form>
      </AuthForm>
      <Modal open={openModal} width={524} closeIcon={<CloseIcon />} onCancel={() => setOpenModal(false)} footer={false} centered>
        <div className='text-center mb-16'>
          <LazyLoadImage src={Images.reactivate} alt='Reactivate Icon' />
        </div>
        <h4 className='text-center'>Reactivate your account</h4>
        <p>
          We have recovered your old Realbricks account. Check your inbox to reactivate it. We have sent an email to{' '}
          <span className='fw-600'>{email}</span>
        </p>
        <p>
          The link will expire in 10 minutes.{' '}
          <span onClick={() => handleResendEmailLink()} className='fw-600 underline text-terracotta cursor-pointer'>
            Resend the email
          </span>{' '}
          if you didn’t receive one, or{' '}
          <a href='https://example.com' className='fw-600 underline text-terracotta'>
            contact support
          </a>{' '}
          with any issues.
        </p>
      </Modal>
      <Modal
        open={newModalVisible}
        onCancel={closeNewSocialModal}
        footer={
          <Button type='primary' className='ant-btn-primary--alt' onClick={handleDoneClick} disabled={hasErrors}>
            Done
          </Button>
        }
      >
        <div>
          <p style={{ marginBottom: '8px', fontWeight: 'bold' }}>Note: Enter your first and last name as it appears on your government issued ID.
            <Tooltip
              placement='bottomRight'
              title={
                <>
                  <p>A government issued ID could be your Passport, Driver’s License, National ID, or Permanent Resident Card.</p>
                  <p className='mb-0'> We are required by federal law to verify the identity of any person seeking to open a financial account.</p>
                </>
              }
            >
              {' '}
              <Info marginLeft='7px' top='2px' />{' '}
            </Tooltip>
          </p>
          <label htmlFor="firstName">FirstName:</label>
          <Input
            id="firstName"
            value={firstName}
            onChange={handleFirstNameChange}
            placeholder='FirstName'
          />
          {firstNameError && <span style={{ color: 'red' }}>{firstNameError}</span>}
        </div>
        <div>
          <label htmlFor="lastName">LastName:</label>
          <Input
            id="lastName"
            value={lastName}
            onChange={handleLastNameChange}
            placeholder='LastName'
          />
          {lastNameError && <span style={{ color: 'red' }}>{lastNameError}</span>}
        </div>
        <div>
          <label htmlFor="phoneNumber">Phone Number:</label>
          <Input
            type='tel'
            id="referralCode"
            value={phoneNumber}
            onChange={handleChangePhoneNumber}
            placeholder='(XXX) XXX-XXXX'
          />
          {phoneNumberError && <span style={{ color: 'red' }}>{phoneNumberError}</span>}
        </div>

        <div>
          <label htmlFor="referredBy">Referral Code:</label>
          <Input
            id="referredBy"
            value={referralLink || referredBy}
            onChange={handleReferralCodeChange}
            placeholder='Referral Code'
            disabled={!!referralLink}
          />
          {referralCodeError && <span style={{ color: 'red' }}>{referralCodeError}</span>}
        </div>
        <div className='mt-20'>
        <Checkbox
            checked={subscribeForSMS && phoneNumber.trim() !== ''}
            onChange={(e) => setSubscribeForSMS(e.target.checked && phoneNumber.trim() !== '')}
            disabled={!phoneNumber.trim()}>Opt-in to be the first to know about new properties. Signup for text messages for early access.
            </Checkbox>
          </div>
      </Modal>
    </div >
  );
};

export default Login;
